<template>
    <table class="table table-sm table-hover" id="venue_table">
        <thead class="thead-light">
            <tr>
                <th scope="col">#</th>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(option, index) in list" :key="option.id"  :id="'venueRow'+option.id">
                <th scope="row" class="venue-cnt">{{ index + 1 }}</th>
                <td class="venue-id">{{ option.id }}</td>
                <td class="venue-name">{{ option.name }}</td>
                <td class="venue-actions text-right">
                    <button v-on:click="selectItem(option)"  class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>
                  <!--  <button v-on:click="editItem(option)" class="btn btn-sm btn-secondary"><i class="fa fa-edit"></i></button> -->
                    <button class="venue-edit-btn btn btn-sm btn-secondary" data-toggle="modal" data-target="#venueEditModal" :data-id="option.id"><i class="fa fa-edit"></i></button>
                    <button v-on:click="removeItem(option)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                </td>               
            </tr>
        </tbody>
    </table>

</template>

<script>

import VenueModal from './VenueModal';

export default {
	components : { VenueModal },
    props: {
        list: Array,
        selected: null,
    },
    data() {
        return {
            venueUrl: '/event/venues',	
            activeModal: 0,
        };
    },
    methods: {
    	showModal: function(id) {
			return this.activeModal === id
    	},
    	toggleModal: function (id) {
    	console.log('User ID: '+id);
    		if (this.aciveModal !== 0) {
    			this.activeModal = 0
    			return false
    		}
    		this.activeModal = id
    	},
        selectItem(item) {
            this.$emit('select', item.id);
        },
        editItem(item) {	
        	//@click="exampleModalShowing = true"
        	//this.$emit('venueModalShowing');
            this.$emit('edit', item);
        },
        removeItem(item) {
            if(confirm('Are you sure you want to delete this?')) {
                axios
                    .delete(this.venueUrl + '/' + item.id)
                    .then(res => {
                        this.$emit('remove', res.data);
                    });
            }
        },
    }
}
</script>